<template>
  <div class="home store-landing">
    <Header/>
    <Banner
      image="hero-image-stores@2x.jpg"
    />
    <StoresList>
      <template slot="title">
        Participating Nike Stores
      </template>
    </StoresList>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import Banner from '@/components/Banner.vue';
import StoresList from '@/components/stores/StoresList.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'stores',
  components: {
    Header,
    Banner,
    StoresList,
    Footer,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/settings.scss";

.store-landing {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
</style>
